import type { ReactNode } from 'react'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@quebon/ui/components/select'

export interface AdminSelectOption {
  value: string
  label: ReactNode
  disabled?: boolean
}

interface AdminSelectProps {
  value: string
  onValueChange: (value: string) => void
  options: readonly AdminSelectOption[]
  ariaLabel: string
  className?: string
}

/**
 * Base Select는 items 없이 controlled string value만 전달하면 트리거에 raw enum을 표시한다.
 * 모든 관리자 Select가 동일한 번역 label을 트리거와 option에 사용하도록 items 등록을 강제한다.
 */
export function AdminSelect({
  value,
  onValueChange,
  options,
  ariaLabel,
  className,
}: AdminSelectProps) {
  return (
    <Select
      items={options}
      value={value}
      onValueChange={(nextValue) => {
        if (typeof nextValue === 'string') onValueChange(nextValue)
      }}
    >
      <SelectTrigger aria-label={ariaLabel} className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
